import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../../_metronic/layout/core';
import { useParams } from 'react-router-dom';
import { decryptId } from '../../../../../_metronic/helpers';
import { ViewCuentasCobrarForm } from './components/View';

const CuentaCobrarForm: FC = () => {
  const { id } = useParams<{ id: string }>();
  const cuentaCobrarId: number = Number(decryptId(id));
  let titulo: string = cuentaCobrarId
    ? `Editar cuenta por cobrar`
    : `Nueva cuenta por cobrar`;

  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Cobranza',
      path: '/cobranza/cuentas_cobrar',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>{titulo}</PageTitle>

      <ViewCuentasCobrarForm cuentaCobrarId={cuentaCobrarId} />
    </>
  );
};

export { CuentaCobrarForm };
